import { create } from 'zustand';
import { getUploadSettings } from '../services/api';

const DEFAULTS = { maxDimension: 1600, jpegQuality: 0.8, maxSizeKb: 900 };

export const useUploadSettingsStore = create((set) => ({
  settings: DEFAULTS,
  loaded: false,
  loading: false,

  load: async () => {
    set({ loading: true });
    try {
      const res = await getUploadSettings();
      set({ settings: { ...DEFAULTS, ...res.data }, loaded: true, loading: false });
    } catch {
      // Network/unauth etc — fall back to defaults silently.
      set({ settings: DEFAULTS, loaded: true, loading: false });
    }
  },

  setSettings: (partial) =>
    set((state) => ({ settings: { ...state.settings, ...partial } })),

  reset: () => set({ settings: DEFAULTS, loaded: false }),
}));

export const getActiveUploadSettings = () => useUploadSettingsStore.getState().settings;
